import { z } from "zod";

export const globalMailSchema = z.object({
    id: z.number().default(-1),
    subject: z.string().default(""),
    body: z.string().default(""),
    from_user: z.number().default(-1),
    from_user_name: z.string().default(""),
    to_users: z.array(z.number()).default([]),
    to_user_count: z.number().default(0),
    to_groups: z.array(z.number()).default([]),
    to_group_names: z.array(z.string()).default([]),
    date_send: z.string().optional(),

    attachments: z.array(z.instanceof(File)).default([]),
});

export type IGlobalMail = z.infer<typeof globalMailSchema>;
